import { useI18nContext } from '@niaratech/niara-react-components';
import React, { Fragment } from 'react';
import formatPointsToParts from '../../util/formatPointsToParts';
import * as S from './styles';
export type PointsProps = {
  value: number;
  color?: string;
  fontWeightAll?: string;
  decimalSize?: number;
  decimalFontWeight?: string;
  decimalLineHeight?: string;
  pointsSize?: number;
  pointsFontWeight?: string;
  pointsLineHeight?: string;
  fractionSize?: number;
  fractionFontWeight?: string;
  fractionLineHeight?: string;
  fractionDigits?: number | undefined | null;
  unitText?: string;
  unitSize?: number;
  unitFontWeight?: string;
};
const Points: React.FC<PointsProps> = ({
  value = 0,
  color,
  fontWeightAll,
  decimalSize,
  decimalFontWeight,
  decimalLineHeight,
  pointsSize,
  pointsFontWeight,
  pointsLineHeight,
  fractionSize,
  fractionFontWeight,
  fractionLineHeight,
  fractionDigits,
  unitText,
  unitSize,
  unitFontWeight
}) => {
  const {
    locale
  } = useI18nContext();
  const pointsInParts = formatPointsToParts(value, locale, fractionDigits);
  return <S.Container>
      {pointsInParts.map((value, index) => {
      let decimal = '';
      let fraction = '';
      let points = '';
      switch (value.type) {
        case 'decimal':
          decimal = value.value;
          break;
        case 'fraction':
          fraction = value.value;
          break;
        default:
          points = value.value;
          break;
      }
      return <Fragment key={index}>
            <S.Coin color={color} fontSize={decimalSize} fontWeight={decimalFontWeight || fontWeightAll} lineHeight={decimalLineHeight}>
              {decimal}
            </S.Coin>

            <S.Coin color={color} fontSize={pointsSize} fontWeight={pointsFontWeight || fontWeightAll} lineHeight={pointsLineHeight}>
              {points}
            </S.Coin>
            <S.Coin color={color} fontSize={fractionSize} fontWeight={fractionFontWeight || fontWeightAll} lineHeight={fractionLineHeight}>
              {fraction}
            </S.Coin>
          </Fragment>;
    })}
      {unitText && <S.Coin color={color} fontSize={unitSize} fontWeight={unitFontWeight || fontWeightAll}>
          {' '}
          {unitText}
        </S.Coin>}
    </S.Container>;
};
export default Points;